import React, { useState, useMemo, useEffect, useCallback } from 'react'
import ReactPlaceholder from 'react-placeholder/lib'
import Controllers from '../../Api/Controllers'
import { Input, FormCustom, Select, SwitchToggle, TextArea } from '../../Components/Form/Form'
import Helpers from '../../Components/Helpers/Helpers'
import ProductPhoto from '../ProductPhoto/ProductPhoto'
import { toast } from 'react-toastify';
import Button from 'react-bootstrap/esm/Button'

const ProductForm = ({ data, onSubmit, disablebSubmit, loadSubmit }) => {
    const [row, setRow] = useState({
        p_id_product: data.id_product,
        p_key_product: data.key_product,
        p_name_product: data.name_product,
        p_description_product: data.description_product,
        p_id_clasification: data.id_clasification,
        p_pack_product: data.pack_product,
        p_stock_min_product: data.stock_min_product,
        p_stock_max_product: data.stock_max_product,
        p_stock_min_branch_office: data.stock_min_branch_office,
        p_stock_max_branch_office: data.stock_max_branch_office,
        p_weight_product: data.weight_product,
        p_price_product: data.price_product,
        p_avaible_store_product: data.avaible_store_product,
        p_description_store_product: data.description_store_product,
        p_id_tax_1: data.id_tax_1,
        p_id_tax_2: data.id_tax_2,
        p_id_tax_3: data.id_tax_3,
        p_id_exempt_1: data.id_exempt_1,
        p_id_exempt_2: data.id_exempt_2,
        p_id_exempt_3: data.id_exempt_3,
        p_iva_product: data.iva_product,
        p_id_branch_office: data.id_branch_office,
        p_is_promo: data.is_promo,
        p_point_min_1: data.point_min_1,
        p_point_min_2: data.point_min_2,
        p_is_kit: data.is_kit,
        p_type_kit: data.type_kit,
        p_bono_kit_pesos: data.bono_kit_pesos,
        p_bono_kit_usd: data.bono_kit_usd,
        p_id_period_promo: data.id_period_promo,
        p_enabled_product: data.enabled_product,
        p_show_in_new_customers: data.show_in_new_customers,
        p_id_product_unit: data.id_product_unit,
        p_has_event: data.has_event,
        p_id_type_event_zone: data.id_type_event_zone,
        p_event_location: data.event_location,
        p_event_date: data.event_date,
        p_event_time: data.event_time,
        p_id_organ: data.id_organ,
        p_benefits_product: data.benefits_product,
        p_dosis_product: data.dosis_product,
        p_observation_product: data.observation_product,
        p_show_bot_product: data.show_bot_product,
        p_bot_name_product: data.bot_name_product,
    })

    const [ready, setReady] = useState(false)
    const [rowsClasification, setRowsClasification] = useState([])
    const [rowsTax, setRowsTax] = useState([])
    const [rowsExempt, setRowsExempt] = useState([])
    const [rowsBranchOffice, setRowsBranchOffice] = useState([])
    const [period, setPeriod] = useState([])
    const [rowsUnits, setRowsUnits] = useState([])
    const [rowsTypeEventZone, setRowsTypeEventZone] = useState([])
    const [rowsOrgan, setRowsOrgan] = useState([])
    const [rowsSuppliers, setRowsSuppliers] = useState([]);
    const [supplierSelected, setSupplierSelected] = useState(null);

    const dataSubmit = useCallback(() => {
        return {
            ...row,
            p_pack_product: parseInt(row.p_pack_product) === 1 ? 1 : 0,
            p_avaible_store_product: parseInt(row.p_avaible_store_product) === 1 ? 1 : 0,
            p_tax: [
                { p_id_tax: row.p_id_tax_1, p_order_tax: 1 },
                { p_id_tax: row.p_id_tax_2, p_order_tax: 2 },
                { p_id_tax: row.p_id_tax_3, p_order_tax: 3 },
            ],
            p_exempt: [
                { p_id_exempt: row.p_id_exempt_1, p_order_exempt: 1 },
                { p_id_exempt: row.p_id_exempt_2, p_order_exempt: 2 },
                { p_id_exempt: row.p_id_exempt_3, p_order_exempt: 3 },
            ]
        }
    }, [row])

    useEffect(() => {
        let promises = [
            Controllers.clasification.get_clasification_all(),
            Controllers.tax.get_tax(),
            Controllers.exempt.get_exempt(),
            Controllers.worker.get_worker_branch_office_public(),
            Controllers.period.get_period(),
            Controllers.product.get_product_unit(),
            Controllers.product.get_type_event_zone(),
            Controllers.product.get_organ(),
            Controllers.supplier.get_supplier(), // <-- cargar proveedores
        ]

        Promise.all(promises).then(res => {
            setRowsClasification(res[0].data)
            setRowsTax(res[1].data)
            setRowsExempt(res[2].data)
            setRowsBranchOffice(res[3].data)
            setPeriod(res[4].data)
            setRowsUnits(res[5].data)
            setRowsTypeEventZone(res[6].data)
            setRowsOrgan(res[7].data)
            setRowsSuppliers(res[8].data)
            // Seleccionar proveedor si existe en data
            if (data.id_supplier) {
                const found = res[8].data.find(s => parseInt(s.supplier_id) === parseInt(data.id_supplier));
                if (found) setSupplierSelected({ label: found.supplier_name, value: found.supplier_id });
            }
            setReady(true)
        })
    }, [])

    const typeMoneyBranchOffice = useCallback(_ => {
        let boFind = rowsBranchOffice.find(bo => parseInt(bo.id_branch_office) === parseInt(row.p_id_branch_office))

        if (boFind) {
            if (parseInt(boFind.id_type_money) === 1) {
                return 'USD'
            } else if (parseInt(boFind.id_type_money) === 2) {
                return 'MXN'
            } else {
                return ''
            }
        }
        return ''
    }, [row.p_id_branch_office, rowsBranchOffice])

    const [kits] = useState([
        { name_kit: 'Básico', value_kit: 'basico' },
        { name_kit: 'Premium', value_kit: 'premium' },
        { name_kit: 'Preferente', value_kit: 'preferente' },
    ])

    const kitSelected = useMemo(() => {
        if (!row.p_type_kit) {
            return
        }

        let finded = kits.find(t => (row.p_type_kit) === (t.value_kit))

        if (!finded) {
            return
        }
        return {
            label: `${finded.name_kit}`,
            value: finded.type_kit
        }
    }, [row.p_type_kit])

    const clasification = useMemo(() => {
        if (!row.p_id_clasification) {
            return
        }

        let finded = rowsClasification.find(t => parseInt(row.p_id_clasification) === parseInt(t.id_clasification))

        if (!finded) {
            return
        }
        return {
            label: `${finded.code_clasification} - ${finded.name_clasification}`,
            value: finded.id_clasification
        }
    }, [row.p_id_clasification, rowsClasification])

    const branchOffice = useMemo(() => {
        if (!row.p_id_branch_office) {
            return
        }

        let finded = rowsBranchOffice.find(t => parseInt(row.p_id_branch_office) === parseInt(t.id_branch_office))

        if (!finded) {
            return
        }
        return {
            label: finded.key_branch_office + ' - ' + finded.name_branch_office,
            value: finded.id_branch_office
        }
    }, [row.p_id_branch_office, rowsBranchOffice])

    const tax_1 = useMemo(() => {
        if (!row.p_id_tax_1) {
            return
        }

        let finded = rowsTax.find(t => parseInt(t.id_tax) === parseInt(row.p_id_tax_1))

        if (!finded) {
            return
        }

        return {
            label: `${finded.name_tax} - ${finded.value_tax}`,
            value: finded.id_tax
        }
    }, [row.p_id_tax_1, rowsTax])

    const tax_2 = useMemo(() => {
        if (!row.p_id_tax_2) {
            return
        }

        let finded = rowsTax.find(t => parseInt(t.id_tax) === parseInt(row.p_id_tax_2))

        if (!finded) {
            return
        }

        return {
            label: `${finded.name_tax} - ${finded.value_tax}`,
            value: finded.id_tax
        }
    }, [row.p_id_tax_2, rowsTax])

    const tax_3 = useMemo(() => {
        if (!row.p_id_tax_3) {
            return
        }

        let finded = rowsTax.find(t => parseInt(t.id_tax) === parseInt(row.p_id_tax_3))

        if (!finded) {
            return
        }

        return {
            label: `${finded.name_tax} - ${finded.value_tax}`,
            value: finded.id_tax
        }
    }, [row.p_id_tax_3, rowsTax])

    const exempt_1 = useMemo(() => {
        if (!row.p_id_exempt_1) {
            return ''
        }

        let finded = rowsExempt.find(t => parseInt(t.id_exempt) === parseInt(row.p_id_exempt_1))

        if (!finded) {
            return ''
        }

        return {
            label: `${finded.name_exempt} - ${finded.value_exempt}`,
            value: finded.id_exempt
        }
    }, [row.p_id_exempt_1, rowsExempt])

    const exempt_2 = useMemo(() => {
        if (!row.p_id_exempt_2) {
            return
        }

        let finded = rowsExempt.find(t => parseInt(t.id_exempt) === parseInt(row.p_id_exempt_2))

        if (!finded) {
            return
        }

        return {
            label: `${finded.name_exempt} - ${finded.value_exempt}`,
            value: finded.id_exempt
        }
    }, [row.p_id_exempt_2, rowsExempt])

    const exempt_3 = useMemo(() => {
        if (!row.p_id_exempt_3) {
            return
        }

        let finded = rowsExempt.find(t => parseInt(t.id_exempt) === parseInt(row.p_id_exempt_3))

        if (!finded) {
            return
        }

        return {
            label: `${finded.name_exempt} - ${finded.value_exempt}`,
            value: finded.id_exempt
        }
    }, [row.p_id_exempt_3, rowsExempt])

    const cboPeriod = useMemo(() => {
        if (!row.p_id_period_promo) {
            return
        }

        let finded = period.find(t => parseInt(row.p_id_period_promo) === parseInt(t.id_period))

        if (!finded) {
            return
        }
        return {
            label: finded.code_period + ' - ' + finded.name_period,
            value: finded.id_period
        }
    }, [row.p_id_period_promo, period])

    const cboUnit = useMemo(() => {
        if (!row.p_id_product_unit) {
            return
        }

        let finded = rowsUnits.find(t => parseInt(row.p_id_product_unit) === parseInt(t.id_product_unit))

        if (!finded) {
            return
        }
        return {
            label: finded.code_product_unit,
            value: finded.id_product_unit
        }
    }, [row.p_id_product_unit, rowsUnits])

    const typeEventZone = useMemo(() => {
        if (!row.p_id_type_event_zone) {
            return
        }

        let finded = rowsTypeEventZone.find(t => parseInt(row.p_id_type_event_zone) === parseInt(t.id_type_event_zone))

        if (!finded) {
            return
        }
        return {
            label: finded.name_type_event_zone,
            value: finded.id_type_event_zone
        }
    }, [row.p_id_type_event_zone, rowsTypeEventZone])

    const cboOrgan = useMemo(() => {
        if (!row.p_id_organ) {
            return
        }

        let finded = rowsOrgan.find(t => parseInt(row.p_id_organ) === parseInt(t.id_organ))

        if (!finded) {
            return
        }
        return {
            label: finded.name_organ,
            value: finded.id_organ
        }
    }, [row.p_id_organ, rowsOrgan])

    return <ReactPlaceholder ready={ready} rows={7}>
        <FormCustom dataSubmit={{...dataSubmit(), id_supplier: supplierSelected ? supplierSelected.value : null}} onSubmit={({ data }) => {
            if (!row.p_id_clasification) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar la clasificación', toast })
                return
            }

            /* if (!row.p_id_tax_1 || !row.p_id_tax_2 || !row.p_id_tax_3) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar los impuestos', toast })
                return 
            }
 
            if ((parseInt(row.p_id_tax_1) === parseInt(row.p_id_tax_2)) || (parseInt(row.p_id_tax_1) === parseInt(row.p_id_tax_3)) || (parseInt(row.p_id_tax_2) === parseInt(row.p_id_tax_3))) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar diferentes impuestos', toast })
                return 
            }

            if (!row.p_id_exempt_1 || !row.p_id_exempt_2 || !row.p_id_exempt_3) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar los excentos', toast })
                return 
            }
 
            if ((parseInt(row.p_id_exempt_1) === parseInt(row.p_id_exempt_2)) || (parseInt(row.p_id_exempt_1) === parseInt(row.p_id_exempt_3)) || (parseInt(row.p_id_exempt_2) === parseInt(row.p_id_exempt_3))) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar diferentes excentos', toast })
                return 
            } */

            if (row.p_has_event) {
                if (!row.p_id_type_event_zone) {
                    Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar la zona de evento', toast })
                    return
                }
            }

            onSubmit({ data })
        }} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit}>
            <Input
                text="Clave"
                placeholder="Clave"
                classNameParent="col-6 mb-2"
                icon="far fa-comment-alt"
                required
                invalid="El campo es obligatorio."
                disabled={parseInt(data.id_product) > 0}
                defaultValue={data.key_product}
                onChange={e => setRow({ ...row, p_key_product: e.currentTarget.value })}
                maxLength={100}
            />
            <Input
                text="Nombre"
                placeholder="Nombre"
                classNameParent="col-6 mb-2"
                icon="far fa-comment-alt"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.name_product}
                onChange={e => setRow({ ...row, p_name_product: e.currentTarget.value })}
                maxLength={255}
            />
            <Input
                text="Descripción"
                placeholder="Descripción"
                classNameParent="col-6 mb-2"
                icon="far fa-comment-alt"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.description_product}
                onChange={e => setRow({ ...row, p_description_product: e.currentTarget.value })}
            />
            <Select
                classNameParent="col-6 mb-2"
                icon="fas fa-dollar-sign"
                text="Clasificación"
                options={rowsClasification.map(t => {
                    return {
                        label: `${t.code_clasification} - ${t.name_clasification}`,
                        value: t.id_clasification
                    }
                })}
                value={clasification}
                onChange={e => setRow({ ...row, p_id_clasification: e.value })}
            />
            <Select
                classNameParent="col-6 mb-2"
                icon="far fa-building"
                text="Sucursal"
                options={rowsBranchOffice.map(t => {
                    return {
                        label: t.key_branch_office + ' - ' + t.name_branch_office,
                        value: t.id_branch_office
                    }
                })}
                value={branchOffice}
                onChange={e => setRow({ ...row, p_id_branch_office: e.value })}
                disabled={!isNaN(parseInt(row.p_id_product))}
            />
            <Select
                classNameParent="col-6 mb-2"
                icon="fas fa-truck"
                text="Proveedor (opcional)"
                options={rowsSuppliers.map(s => ({ label: s.supplier_name, value: s.supplier_id }))}
                value={supplierSelected}
                onChange={e => setSupplierSelected(e)}
                isClearable={true}
            />
            <SwitchToggle
                id="product-is-pack"
                defaultChecked={parseInt(data.pack_product) === 1}
                onChange={e => setRow({ ...row, p_pack_product: e.currentTarget.checked ? 1 : 0 })}
                classNameParent="col-12 mb-2"
                textCheck="Es Paquete"
                textUnChecked="No Es Paquete"
                disabled={!isNaN(parseInt(row.p_id_product))}
            />
            <Input
                text="Stock Mínimo Almacen General"
                placeholder="Stock Mínimo Almacen General"
                type="number"
                classNameParent="col-6 mb-2"
                icon="fas fa-dollar-sign"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.stock_min_product}
                onChange={e => setRow({ ...row, p_stock_min_product: e.currentTarget.value })}
            />
            <Input
                text="Stock Maximo Almacen General"
                placeholder="Stock Maximo Almacen General"
                type="number"
                classNameParent="col-6 mb-2"
                icon="fas fa-dollar-sign"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.stock_max_product}
                onChange={e => setRow({ ...row, p_stock_max_product: e.currentTarget.value })}
            />
            <Input
                text="Stock Mínimo Sucursal"
                placeholder="Stock Mínimo Sucursal"
                type="number"
                classNameParent="col-6 mb-2"
                icon="fas fa-dollar-sign"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.stock_min_branch_office}
                onChange={e => setRow({ ...row, p_stock_min_branch_office: e.currentTarget.value })}
            />
            <Input
                text="Stock Maximo Sucursal"
                placeholder="Stock Maximo Sucursal"
                type="number"
                classNameParent="col-6 mb-2"
                icon="fas fa-dollar-sign"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.stock_max_branch_office}
                onChange={e => setRow({ ...row, p_stock_max_branch_office: e.currentTarget.value })}
            />
            <Input
                text="Peso"
                placeholder="Peso"
                type="number"
                classNameParent="col-6 mb-2"
                icon="fas fa-dollar-sign"
                required
                invalid="El campo es obligatorio."
                min="0.10"
                step="0.10"
                defaultValue={data.weight_product}
                onChange={e => setRow({ ...row, p_weight_product: e.currentTarget.value })}
            />
            <Input
                text="Costo Producción"
                placeholder="Costo Producción"
                type="number"
                classNameParent="col-6 mb-2"
                icon="fas fa-dollar-sign"
                required
                invalid="El campo es obligatorio."
                min="0.10"
                step="0.10"
                defaultValue={data.price_product}
                onChange={e => setRow({ ...row, p_price_product: e.currentTarget.value })}
            />
            {/* <Select
                classNameParent="col-6 mb-2"
                icon="fas fa-percentage"
                text="Impuesto 1"
                options={rowsTax.map(t => {
                    return {
                        label: `${t.name_tax} - ${t.value_tax}`,
                        value: t.id_tax
                    }
                })}
                value={tax_1}
                onChange={e => setRow({ ...row, p_id_tax_1: e.value })}
            />
            <Select
                classNameParent="col-6 mb-2"
                icon="fas fa-percentage"
                text="Impuesto 2"
                options={rowsTax.map(t => {
                    return {
                        label: `${t.name_tax} - ${t.value_tax}`,
                        value: t.id_tax
                    }
                })}
                value={tax_2}
                onChange={e => setRow({ ...row, p_id_tax_2: e.value })}
            />
            <Select
                classNameParent="col-6 mb-2"
                icon="fas fa-percentage"
                text="Impuesto 3"
                options={rowsTax.map(t => {
                    return {
                        label: `${t.name_tax} - ${t.value_tax}`,
                        value: t.id_tax
                    }
                })}
                value={tax_3}
                onChange={e => setRow({ ...row, p_id_tax_3: e.value })}
            /> */}
            {/* <Input
                text="IVA"
                placeholder="IVA"
                classNameParent="col-6 mb-2"
                icon="far fa-comment-alt"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.iva_product}
                onChange={e => setRow({ ...row, p_iva_product: e.currentTarget.value })}
            /> */}
            <SwitchToggle
                id="product-enabled"
                defaultChecked={parseInt(data.enabled_product) === 1}
                onChange={e => setRow({ ...row, p_enabled_product: e.currentTarget.checked ? 1 : 0 })}
                classNameParent="col-12 mb-2 mt-2"
                textCheck="Activo"
                textUnChecked="Inactivo"
            />

            <p className="col-12 mb-1 mt-2 font-weight-bold">
                Información de Tienda en Línea
            </p>
            <SwitchToggle
                id="product-avaible-store"
                defaultChecked={parseInt(data.avaible_store_product) === 1}
                onChange={e => setRow({ ...row, p_avaible_store_product: e.currentTarget.checked ? 1 : 0 })}
                classNameParent="col-12 mb-2"
                textCheck="Disponible en Tienda Online"
                textUnChecked="No Disponible en Tienda Online"
            />
            <Select
                classNameParent="col-6 mb-2"
                icon="fas fa-percentage"
                text="Excento 1"
                options={rowsExempt.map(t => {
                    return {
                        label: `${t.name_exempt} - ${t.value_exempt}`,
                        value: t.id_exempt
                    }
                })}
                value={exempt_1}
                onChange={e => setRow({ ...row, p_id_exempt_1: e.value })}
                append={[
                    row.p_id_exempt_1 ? <Button type="button" variant="danger" title="Eliminar" onClick={_ => {
                        setRow({ ...row, p_id_exempt_1: '' })
                    }}>
                        <i className="fas fa-times"></i>
                    </Button> : ''
                ]}
            />
            <Select
                classNameParent="col-6 mb-2"
                icon="far fa-comment-alt"
                text="Unidad de Medida"
                options={rowsUnits.map(t => {
                    return {
                        label: t.code_product_unit,
                        value: t.id_product_unit
                    }
                })}
                value={cboUnit}
                onChange={e => setRow({ ...row, p_id_product_unit: e.value })}
            />
            {/* <Select
                classNameParent="col-6 mb-2"
                icon="fas fa-percentage"
                text="Excento 2"
                options={rowsExempt.map(t => {
                    return {
                        label: `${t.name_exempt} - ${t.value_exempt}`,
                        value: t.id_exempt
                    }
                })}
                value={exempt_2}
                onChange={e => setRow({ ...row, p_id_exempt_2: e.value })}
            />
            <Select
                classNameParent="col-6 mb-2"
                icon="fas fa-percentage"
                text="Excento 3"
                options={rowsExempt.map(t => {
                    return {
                        label: `${t.name_exempt} - ${t.value_exempt}`,
                        value: t.id_exempt
                    }
                })}
                value={exempt_3}
                onChange={e => setRow({ ...row, p_id_exempt_3: e.value })}
            /> */}
            <Input
                text="Descripción Tienda en Línea"
                placeholder="Descripción Tienda en Línea"
                classNameParent="col-6 mb-2"
                icon="far fa-comment-alt"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.description_store_product}
                onChange={e => setRow({ ...row, p_description_store_product: e.currentTarget.value })}
            />
            <div className="col-12">
                <hr />
            </div>
            <SwitchToggle
                id="product-is-promo"
                defaultChecked={parseInt(data.is_promo) === 1}
                onChange={e => setRow({ ...row, p_is_promo: e.currentTarget.checked ? 1 : 0 })}
                classNameParent="col-12 mb-2"
                textCheck="Es Promo"
                textUnChecked="No Es Promo"
            />
            {parseInt(row.p_is_promo) === 1 && <>
                <Input
                    text="Puntos Mínimos"
                    placeholder="Puntos Mínimos"
                    classNameParent="col-6 mb-2"
                    icon="far fa-comment-alt"
                    required
                    invalid="El campo es obligatorio."
                    defaultValue={data.point_min_1}
                    onChange={e => setRow({ ...row, p_point_min_1: e.currentTarget.value })}
                    type="number"
                    step="1"
                    min="1"
                />
                {/* <Input
                    text="Puntos Mínimos 2"
                    placeholder="Puntos Mínimos 2"
                    classNameParent="col-6 mb-2"
                    icon="far fa-comment-alt"
                    invalid="El campo es obligatorio."
                    defaultValue={data.point_min_2}
                    onChange={e => setRow({ ...row, p_point_min_2: e.currentTarget.value })}
                    type="number"
                    step="1"
                    min="1"
                    disabled={!isNaN(parseInt(row.p_id_product))}
                /> */}
                <Select
                    classNameParent="col-6 mb-2"
                    icon="fas fa-percentage"
                    text="Periodo Promo"
                    options={period.map(t => {
                        return {
                            label: `${t.code_period} - ${t.name_period}`,
                            value: t.id_period
                        }
                    })}
                    value={cboPeriod}
                    onChange={e => setRow({ ...row, p_id_period_promo: e.value })}
                />
            </>}
            <SwitchToggle
                id="product-is-kit"
                defaultChecked={parseInt(data.is_kit) === 1}
                onChange={e => setRow({ ...row, p_is_kit: e.currentTarget.checked ? 1 : 0 })}
                classNameParent="col-12 mb-2"
                textCheck="Es Kit"
                textUnChecked="No Es Kit"
            />
            <SwitchToggle
                id="product-is-show_in_new_customers"
                defaultChecked={parseInt(data.show_in_new_customers) === 1}
                onChange={e => setRow({ ...row, p_show_in_new_customers: e.currentTarget.checked ? 1 : 0 })}
                classNameParent="col-12 mb-2"
                textCheck="Aparece en Alta de Clientes"
                textUnChecked="No Aparece en Alta de Clientes"
            />
            {parseInt(row.p_is_kit) === 1 && <>
                <Select
                    classNameParent="col-6 mb-2"
                    icon="fas fa-percentage"
                    text="Tipo de Kit"
                    options={kits.map(t => {
                        return {
                            label: t.name_kit,
                            value: t.value_kit
                        }
                    })}
                    value={kitSelected}
                    onChange={e => setRow({ ...row, p_type_kit: e.value, p_bono_kit_pesos: '', p_bono_kit_usd: '' })}
                />
                {typeMoneyBranchOffice() === 'MXN' && <Input
                    text="Bono Pesos"
                    placeholder="Bono Pesos"
                    type="number"
                    classNameParent="col-6 mb-2"
                    icon="fas fa-dollar-sign"
                    required
                    invalid="El campo es obligatorio."
                    min="0.10"
                    step="0.10"
                    value={row.p_bono_kit_pesos}
                    onChange={e => setRow({ ...row, p_bono_kit_pesos: e.currentTarget.value })}
                />}
                {typeMoneyBranchOffice() === 'USD' && <Input
                    text="Bono Dólares"
                    placeholder="Bono Dólares"
                    type="number"
                    classNameParent="col-6 mb-2"
                    icon="fas fa-dollar-sign"
                    required
                    invalid="El campo es obligatorio."
                    min="0.10"
                    step="0.10"
                    value={row.p_bono_kit_usd}
                    onChange={e => setRow({ ...row, p_bono_kit_usd: e.currentTarget.value })}
                />}
            </>}

            <SwitchToggle
                id="product-is-has_event"
                defaultChecked={parseInt(data.has_event) === 1}
                onChange={e => setRow({ ...row, p_has_event: e.currentTarget.checked ? 1 : 0 })}
                classNameParent="col-12 mb-2"
                textCheck="Es Evento"
                textUnChecked="No es Evento"
            />
            {parseInt(row.p_has_event) === 1 && <>
                <Select
                    classNameParent="col-6 mb-2"
                    icon="fas fa-percentage"
                    text="Zona de Evento"
                    options={rowsTypeEventZone.map(t => {
                        return {
                            label: t.name_type_event_zone,
                            value: t.id_type_event_zone
                        }
                    })}
                    value={typeEventZone}
                    onChange={e => setRow({ ...row, p_id_type_event_zone: e.value })}
                />
                <Input
                    text="Ubicación"
                    placeholder="Ubicación"
                    classNameParent="col-6 mb-2"
                    icon="far fa-comment-alt"
                    required
                    invalid="El campo es obligatorio."
                    defaultValue={data.event_location}
                    onChange={e => setRow({ ...row, p_event_location: e.currentTarget.value })}
                    step="1"
                    min="1"
                />
                <Input
                    text="Fecha"
                    placeholder="Fecha"
                    classNameParent="col-6 mb-2"
                    icon="far fa-comment-alt"
                    required
                    invalid="El campo es obligatorio."
                    defaultValue={data.event_date}
                    onChange={e => setRow({ ...row, p_event_date: e.currentTarget.value })}
                    type="date"
                    step="1"
                    min="1"
                />
                <Input
                    text="Hora"
                    placeholder="Hora"
                    classNameParent="col-6 mb-2"
                    icon="far fa-comment-alt"
                    required
                    invalid="El campo es obligatorio."
                    defaultValue={data.event_time}
                    onChange={e => setRow({ ...row, p_event_time: e.currentTarget.value })}
                    type="time"
                    step="1"
                    min="1"
                />
            </>}
            <div className="col-12">
                <hr />
            </div>
            <p className="col-12 mb-1 mt-2 font-weight-bold">
                Información para bot
            </p>
            <SwitchToggle
                id="p_show_bot_product"
                defaultChecked={parseInt(data.show_bot_product) === 1}
                onChange={e => setRow({ ...row, p_show_bot_product: e.currentTarget.checked ? 1 : 0 })}
                classNameParent="col-12 mb-2"
                textCheck="Ver en Bot"
                textUnChecked="No ver en bot"
            />
            {parseInt(row.p_show_bot_product) == 1 && <>
                <Select
                    classNameParent="col-6 mb-2"
                    icon="fas fa-percentage"
                    text="Organo o Sistema que ayuda"
                    options={rowsOrgan.map(t => {
                        return {
                            label: `${t.name_organ}`,
                            value: t.id_organ
                        }
                    })}
                    value={cboOrgan}
                    onChange={e => setRow({ ...row, p_id_organ: e.value })}
                />
                <Input
                    text="Nombre en Bot"
                    placeholder="Nombre en Bot"
                    classNameParent="col-6 mb-2"
                    icon="far fa-comment-alt"
                    required
                    invalid="El campo es obligatorio."
                    defaultValue={data.bot_name_product}
                    onChange={e => setRow({ ...row, p_bot_name_product: e.currentTarget.value })}
                    maxLength={255}
                />
                <TextArea
                    text="Beneficios"
                    classNameParent="col-12 mb-2"
                    rows="5"
                    value={row.p_benefits_product}
                    onChange={e => setRow({
                        ...row,
                        p_benefits_product: e.currentTarget.value
                    })}
                />
                <TextArea
                    text="Dosis Recomendada"
                    classNameParent="col-12 mb-2"
                    rows="5"
                    value={row.p_dosis_product}
                    onChange={e => setRow({
                        ...row,
                        p_dosis_product: e.currentTarget.value
                    })}
                />
                <TextArea
                    text="Observaciones"
                    classNameParent="col-12 mb-2"
                    rows="5"
                    value={row.p_observation_product}
                    onChange={e => setRow({
                        ...row,
                        p_observation_product: e.currentTarget.value
                    })}
                />
            </>}
        </FormCustom>
        {data.id_product ? <div className="mt-3">
            <ProductPhoto nameSingle={Helpers.string.toCamelCase('Foto')} namePlural={Helpers.string.toCamelCase('Fotos')} separator={'el'.toLowerCase()} idProduct={data.id_product} />
        </div> : ''}
    </ReactPlaceholder>
}

ProductForm.defaultProps = {
    data: {
        id_product: '',
        name_product: '',
        key_product: '',
        description_product: '',
        id_clasification: '',
        pack_product: 0,
        stock_min_product: '',
        stock_max_product: '',
        stock_min_branch_office: '',
        stock_max_branch_office: '',
        weight_product: '',
        price_product: '',
        avaible_store_product: 0,
        description_store_product: '',
        id_tax_1: '',
        id_tax_2: '',
        id_tax_3: '',
        id_exempt_1: '',
        id_exempt_2: '',
        id_exempt_3: '',
        iva_product: '',
        id_branch_office: '',
        is_promo: 0,
        point_min_1: '',
        point_min_2: '',
        is_kit: 0,
        type_kit: '',
        bono_kit_pesos: '',
        bono_kit_usd: '',
        enabled_product: 0,
        show_in_new_customers: 0,
        id_product_unit: '',
        id_organ: '',
        benefits_product: '',
        dosis_product: '',
        observation_product: '',
        show_bot_product: 0,
        bot_name_product: '',
    },
    onSubmit: () => { },
    loadSubmit: false
}

export default ProductForm;